module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/sash-window/sash-window.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/sash-window/sash-window.obj
// module id = 488
// module chunks = 0